import(/* webpackMode: "eager" */ "/root/indoor/apps/web/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["BrandingProvider"] */ "/root/indoor/apps/web/src/components/providers/branding-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/root/indoor/apps/web/src/components/providers/query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceWorkerRegistration"] */ "/root/indoor/apps/web/src/components/providers/service-worker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/root/indoor/apps/web/src/components/ui/toast.tsx");
